import request from '@/utils/server'


export function getMenuList(query) {
    return request({
      url: '/menu/getMenuList',
      method: 'get',
      params: query
    })
  }